/* eslint-disable prettier/prettier */
import React from "react"
import AOS from "aos"
import CardLeft from "./CardLeft"
import CardRight from "./CardRight"
import style from "./Events.module.css"
import "aos/dist/aos.css"
import decipherImagePath from "./img/decipher.jpg"
import fakeInvestorsImagePath from "./img/fake_investors.jpg"
import innovationExpressImagePath from "./img/innovation_express.png"
import innovationQuestImagePath from "./img/innovation_quest.jpg"
import shootOProblemImagePath from "./img/shoot_o_problem.jpg"

const Events = () => {
  AOS.init({
    duration: 1200,
    offset: 250
  })

  return (
    <div className="bodycontanier">
      <div className={`heading ${style.eventsHeading}`}>
        <h4>EVENTS</h4>
        <h4>EVENTS</h4>
      </div>
      <div className="container">
        <div className={`eventIntro ${style.eventsIntro}`}>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores
          suscipit dolorem delectus voluptates explicabo voluptas provident,
          nostrum nam deserunt possimus nihil iure, commodi nisi doloribus
          eveniet itaque tenetur tempora totam.
        </div>

        <CardLeft
          imgUrl={fakeInvestorsImagePath}
          Title="Fake Investors"
          // eventAnim={window.innerWidth <= 420 ? "fade-up" : "fade-left"}
          Description="Are you a dumbfounding innovator and have astounding ideas? If yes then, come up with a fabricated idea that would change the course of human development.
            You think you have got all that potential to put an excellent idea in the form of a working model, but waiting for an opportunity... The wait is over now.A wonderful platform where you can improvise your innovative ideas in front of the investment panel.It’s time to think ‘out of the box’."
        />

        <CardRight
          imgUrl={innovationQuestImagePath}
          Title="Innovation Quest"
          // eventAnim={window.innerWidth <= 420 ? "fade-up" : "fade-right"}
          Description="A Socio-Case study event in which we address the most pressing problems of our daily routine, which can be tackled with the trending technologies. It is a 2 round event which includes abstract submission and Presentation & Pitching of your idea in respective rounds.

            We believe our participants have the caliber to develop a new approach and bring the best sustainable solutions."
        />
        <CardLeft
          imgUrl={decipherImagePath}
          Title="Decipher"
          // eventAnim={window.innerWidth <= 420 ? "fade-up" : "fade-left"}
          Description="DECIPHER to bemuse your curious minds. We'll be releasing puzzles related to innovations, which were helpful at the time of COVID.And all you have to do is send answers to the puzzles in our chatbox of our social media handles.
            All puzzlers can participate by directly sending their answers to our official accounts. Early response will give you more points.Winners will be declared on the basis of average marks of all the six days"
        />

        <CardRight
          imgUrl={innovationExpressImagePath}
          Title="The Innovation Express"
          // eventAnim={window.innerWidth <= 420 ? "fade-up" : "fade-right"}
          Description="one of the most interesting weekends of IIT(BHU) “ The Innovation Express”(TIE), which contains a series of mindblowing and astonishing events under three categories. Take part to get a taste of what it really means to be a part of this fast-moving and lucrative paradigm of technology!
            Workshops are here to drive away your worries. We are conducting workshops for each of these events so that you can get some knowledge of what exactly the event is.
            "
        />
        <CardLeft
          imgUrl={shootOProblemImagePath}
          Title="Shoot-o-Problem"
          // eventAnim={window.innerWidth <= 420 ? "fade-up" : "fade-left"}
          Description="An Online event called Shoot-o-Problem where students of colleges across India will shoot a 2 minute video of some unique and unidentified problems in their respective hometowns. This video will be shared from our Facebook page and would be judged on the basis of genuinity and popularity of the problem video according to the judging criteria mentioned in the Problem Statement attached in the link below.
          "
        />
      </div>
    </div>
  )
}

export default Events
